import { render, staticRenderFns } from "./LqRadio.vue?vue&type=template&id=40c3d6c0&scoped=true&"
import script from "./LqRadio.vue?vue&type=script&lang=js&"
export * from "./LqRadio.vue?vue&type=script&lang=js&"
import style0 from "./LqRadio.vue?vue&type=style&index=0&id=40c3d6c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c3d6c0",
  null
  
)

export default component.exports